import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              END-TO-END <span className="purple"> SAAS, ERP & CRM DELIVERY </span>
            </h1>
            <p className="home-about-body">
              <b className="purple">Cyborg Solution</b> builds production-grade <b className="purple">ERP, CRM, AI automation, SaaS platforms,</b> 
              and <b className="purple">web app development</b> projects for SaaS founders, startups, SMBs, and enterprises.
              <br />
              <br />
              <b className="purple">Idea → Design → Development → Deployment:</b>
              <br />
              We own the full lifecycle—strategy, UX, architecture, full-stack development, DevOps, and release—so you can move fast with confidence.
              <br />
              <br />
              <b className="purple">Built for Speed, Productivity & ROI:</b>
              <br />
              Reduce backlog, automate workflows, unlock real-time data insights, and scale reliably—without sacrificing code quality or delivery timelines.
              <br />
              <br />
              <b className="purple">Technical Credibility:</b>
              <br />
              Full-stack development across <b className="purple">React, Node.js, Python, FastAPI, AWS, Docker, Kubernetes</b>, 
              with scalable architecture, secure APIs, and production-ready pipelines.
              <br />
              <br />
              <b className="purple">Recent Production Platforms:</b>
              <br />
              <b className="purple">Enterprise ERP/CRM System</b> with real-time dashboards, audit logs, IP whitelisting, PDF generation, and localization.
              <br />
              <b className="purple">AI Property Management CRM</b> with automated workflows, analytics dashboards, and AI-assisted operations.
              <br />
              <b className="purple">Real Estate Deal CRM</b> built with FastAPI (60+ endpoints), JWT auth, and export-ready reporting.
              <br />
              <br />
              <b className="purple">Let’s discuss your platform.</b> Schedule a consultation or reach out to explore ERP, CRM, SaaS development, AI automation, 
              and enterprise software solutions tailored to your roadmap.
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
